import React from 'react'

const DeviceIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="56"
    height="56.7"
    viewBox="0 0 80 81"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}>
    <rect width="80" height="81" fill="#fff" />
    <circle
      cx="40"
      cy="40.093"
      r="38.387"
      fill="#fff"
      stroke="#eee"
      strokeWidth={3.227}
    />
    <g
      clipPath="url(#clip0)"
      stroke="#78BE20"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path
        d="M31.778 46.566h16.328c.902 0 1.633-.731 1.633-1.633V33.504c0-.902-.731-1.633-1.633-1.633H31.778c-.902 0-1.633.731-1.633 1.633v11.429c0 .902.731 1.633 1.633 1.633Z"
        fill="#fff"
      />
      <path d="M43.208 49.832h-6.531" />
      <path d="M30.146 42.484h19.594" />
      <path d="M39.942 46.566v3.266" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="26.125"
          height="26.125"
          transform="translate(26.88 26.973)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default DeviceIcon
